import React, { useState, useEffect } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import Select from 'react-select'
import { useForm } from 'react-hook-form'
import { Table, Button } from 'react-bootstrap'
import axios from 'axios'
import Papa from 'papaparse'
import ConfirmModal from '../ui/ConfirmModal'

function ActImport() {
  const { id } = useParams()
  const [csvData, setCsvData] = useState([])
  const [importModalOpen, setImportModalOpen] = useState(false)
  const [importModalMessage, setImportModalMessage] = useState('')

  const handleFileUpload = (event) => {
    const file = event.target.files[0]

    Papa.parse(file, {
      header: false, // No headers in this CSV format
      complete: handleParsedData,
    })
  }

  const handleParsedData = (parsedData) => {
    setCsvData(parsedData.data)
  }

  const saveToMongoDB = () => {
    fetch(`${process.env.REACT_APP_BASE_URL}saveactscsv`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        testId: id,
        csvData: csvData,
      }),
    })
      .then((response) => {
        if (response.ok) {
          return response.text()
        } else {
          throw new Error('Failed to save data')
        }
      })
      .then((message) => {
        setImportModalMessage('Data saved successfully')
        setImportModalOpen(true)
      })
      .catch((error) => {
        setImportModalMessage('An error occurred while saving data')
        setImportModalOpen(true)
      })
  }

  return (
    <div className="w-full mt-2.5 max-md:max-w-full">
      {/* Header */}
      <div className="flex justify-between items-center border border-[#F0F0F0] bg-white px-5 py-4 rounded-t-[10px]">
        <h2 className="text-lg font-bold text-[#030303]">Test Answer Key</h2>
        <Link
          className="bg-[#DE3C7D] text-white px-4 py-2 rounded-md hover:bg-[#c72c6a] transition-colors font-medium"
          to="/tests"
        >
          Back to Act Tests
        </Link>
      </div>
      {/* CSV Import Section */}
      <div className="flex items-center gap-4 bg-white border-x border-[#F0F0F0] px-5 py-4 rounded-b-[10px]">
        <input
          type="file"
          accept=".csv"
          onChange={handleFileUpload}
          className="block w-60 text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-[#EFEFEF] file:text-[#DE3C7D] hover:file:bg-[#DE3C7D] hover:file:text-white"
        />
        <button
          className="bg-[#EFEFEF] text-[#DE3C7D] px-4 py-2 rounded-md border border-[#DE3C7D] font-medium hover:bg-[#DE3C7D] hover:text-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          onClick={saveToMongoDB}
          disabled={!csvData || !Array.isArray(csvData) || csvData.length === 0}
        >
          Import Questions
        </button>
      </div>
      <ConfirmModal
        open={importModalOpen}
        title="Import Questions"
        message={importModalMessage}
        onCancel={() => setImportModalOpen(false)}
        onConfirm={() => setImportModalOpen(false)}
      />
    </div>
  )
}
export default ActImport
